import { render, staticRenderFns } from "./book-info.vue?vue&type=template&id=f3a6fe2c&scoped=true"
import script from "./book-info.vue?vue&type=script&lang=js"
export * from "./book-info.vue?vue&type=script&lang=js"
import style0 from "./book-info.vue?vue&type=style&index=0&id=f3a6fe2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a6fe2c",
  null
  
)

export default component.exports